module.exports = __webpack_public_path__ + "static/media/bb-1.bd7f8709.png";